module.exports = __webpack_public_path__ + "static/sp2-40a071c80d0b92e8497c93ec47be0df2.jpg";